export default function searchbar() {
    var algoliasearch = require('algoliasearch');
    var autocomplete = require('autocomplete.js');

    var algoliaClient = algoliasearch(window.parameters.algolia_app_id, window.parameters.algolia_searchonly_api_key);
    var algoliaVehicleIndex = algoliaClient.initIndex(window.parameters.algolia_vehicle_index);

    function initAutocompleteSearchbar() {
        if( $('.autocomplete-search').length != 0) {

            autocomplete('.autocomplete-search',
                { hint: false },
                [
                    {
                        name: 'maker',
                        source: function(query, callback) {
                            var filters = "";

                            //Filter on agency stock
                            if (window.parameters.site != undefined && window.parameters.site.site_code == 'agency') {
                                filters = "mainAgency:" + window.parameters.site.id;
                            }

                            algoliaVehicleIndex.search(
                                {
                                    query: query,
                                    facets: ['maker.name'],
                                    filters: filters
                                }).then(function(answer) {
                                    var makerFacets = answer.facets['maker.name'];
                                    var arrayReturn = [];

                                    for( var key in makerFacets) {
                                        arrayReturn.push({'name': key, 'count': makerFacets[key]})
                                    }

                                    callback(arrayReturn);

                            }, function() {
                                callback([]);
                            });
                        },
                        templates: {
                            header: '<div class="label-title">Marque</div>',
                            suggestion: function(suggestion) {
                                return suggestion.name + ' <span class="motor-count">' + suggestion.count + '</span>';
                            }
                        }
                    },
                    {
                        name: 'model',
                        source: function(query, callback) {
                            var filters = "";

                            //Filter on agency stock
                            if (window.parameters.site != undefined && window.parameters.site.site_code == 'agency') {
                                filters = "mainAgency:" + window.parameters.site.id;
                            }

                            algoliaVehicleIndex.search(
                                {
                                    query: query,
                                    facets: ['model.object'],
                                    filters: filters
                                }).then(function(answer) {
                                var modelFacets = answer.facets['model.object'];
                                var arrayReturn = [];

                                for( var key in modelFacets) {
                                    var modelObject = $.parseJSON(key);

                                    arrayReturn.push({'fullName': modelObject.fullName, 'name' : modelObject.name, 'makerName': modelObject.makerName, 'count': modelFacets[key]})
                                }

                                callback(arrayReturn);

                            }, function() {
                                callback([]);
                            });
                        },
                        templates: {
                            header: '<div class="label-title">Modèle</div>',
                            suggestion: function(suggestion) {
                                return suggestion.fullName + ' <span class="motor-count">' + suggestion.count + '</span>';
                            }
                        }
                    },
                ]
            ).on('autocomplete:selected', function(event, suggestion, dataset) {
                var redirectUrl = '';

                var siteCode = window.parameters.site.site_code;

                if( dataset == 'maker') {
                    if(siteCode == 'agency') {
                        redirectUrl = Routing.generate('vehicle_search', {
                            dFR: {'maker.name': [suggestion.name]},
                            hostname: window.location.hostname
                        });
                    } else {
                        redirectUrl = Routing.generate('vehicle_search', {dFR: {'maker.name': [suggestion.name]}});
                    }


                } else if(dataset == 'model') {
                    if(siteCode == 'agency') {
                        redirectUrl = Routing.generate('vehicle_search', {
                            dFR: {'maker.name': [suggestion.makerName], 'model.name': [suggestion.name]},
                            hostname: window.location.hostname
                        });
                    } else {
                        redirectUrl = Routing.generate('vehicle_search', {dFR: {'maker.name': [suggestion.makerName], 'model.name': [suggestion.name]}});
                    }
                }

                if( redirectUrl != '') {
                    window.location.replace(redirectUrl);
                }
            });
        }
    }

    $(document).ready(function() {
        initAutocompleteSearchbar();
    });
};


// WEBPACK FOOTER //
// ./app/Resources/assets/default/js/homepage/searchbar.js